App.factory('Campaign', [
  'restmod',
  '$api',
  (restmod, $api) => {
    return restmod.model('/campaigns').mix({
      logs: { hasMany: 'CampaignLog' },
      campaign_setting: {
        init: function () {
          return {
            provider_ids: [],
            recipients_added_ids: [],
            recipients_removed_ids: [],
            last_seen_appointment_provider_ids: [],
            appointment_provider_ids: [],
            last_seen_appointment_type_ids: [],
            appointment_type_ids: [],
            last_seen_appointment_status: [],
            appointment_status: [],
            recall_type_names: []
          }
        },
      },
      campaign_layout: { init: {} },
      'campaign_setting.appt_to': {
        decode: function (val) {
          return val === null ? null : moment.utc(val)
        },
      },
      'campaign_setting.appt_from': {
        decode: function (val) {
          return val === null ? null : moment.utc(val)
        },
      },
      'campaign_setting.last_seen_appt_from': {
        decode: function (val) {
          return val === null ? null : moment.utc(val)
        },
      },
      'campaign_setting.last_seen_appt_to': {
        decode: function (val) {
          return val === null ? null : moment.utc(val)
        },
      },
      $hooks: {
        'before-request'(_req) {
          _req.timeout = 20 * 60 * 1000 // 20 minutes, in case of uploading large CSV patients file
        },
      },
      $extend: {
        Model: {
          $copy: function (id, params = {}) {
            return $api('POST', `/campaigns/${id}/copy`, params)
          },
          $deleteLocation: function (uuid, locationId, params = {}) {
            return $api('DELETE', `/campaigns/${uuid}/locations/${locationId}`, params)
          },
        },
      },
    })
  },
])
